export default {"src":"/_next/static/media/hive.969bbb5a.svg","height":190,"width":220,"blurWidth":0,"blurHeight":0};